import * as Sentry from "@sentry/vue";
import type { App } from "vue";
import type { Router } from "vue-router";
import { showChunkLoadFailure } from "../chunkLoadFailure";
import { installChunkErrorReporting } from "./chunkErrors";
import { sentryEnvironment } from "./environment";
import { reportChunkError, tagChunkErrorEvent } from "./Sentry";

const SENTRY_DSN = "https://32a80a5331edddb49c5786a1b856b2a2@o4508029466771456.ingest.de.sentry.io/4508029469524048";

/**
 * Call after createApp() and before app.use(router) / app.mount(): the router starts its first
 * navigation (and the first lazy chunk import) on install, and the Vue error handler is attached here.
 *
 * Release: sentryVitePlugin injects `SENTRY_RELEASE` (the commit hash) into the bundle in CI builds and the
 * SDK reads it, so no `release` option is set here. Local builds have the plugin off and send no release.
 */
export function initSentry(app: App, router: Router) {
	Sentry.init({
		app,
		dsn: SENTRY_DSN,
		enabled: !import.meta.env.DEV,
		environment: sentryEnvironment(location.hostname),
		tracesSampleRate: 0.05,
		integrations: [Sentry.browserTracingIntegration({ enableInp: true })],
		beforeSend: tagChunkErrorEvent,
	});

	installChunkErrorReporting({
		target: window,
		router,
		report: reportChunkError,
		pageUrl: () => location.href,
		onFailure: showChunkLoadFailure,
	});
}
